import React from "react";
import { Button, Container, Row, Col } from "reactstrap";

function CardProgetti() {
  return (
    <>
      <div className="section section-dark">
        {/* Inizio del container */}
        <Container>

            <h2 className="title text-center">Esempi</h2>

            {/* Inizio della 1° riga */}
            <Row className="example-page">
                
                {/* Inizio 1° Card */}
                <Col className="text-center" md="6">
                    {/* Immagine */}
                    <a href="https://github.com/MattiaBracco05/SCUOLA/tree/b6d58416f036d76d7213498d6e499b940ad1a085/5L/TPSIT/Node%20JS/registrazione_punteggi_videogiochi" target="_blank">
                        <img
                        alt="..."
                        className="img-rounded img-responsive"
                        src={require("assets/img/Indice/esempi.jpg")}
                        style={{ width: "100%" }}
                        />
                    </a>
                    {/* Button */}
                    <Button
                        className="btn-outline-neutral btn-round"
                        color="default"
                        href="https://github.com/MattiaBracco05/SCUOLA/tree/b6d58416f036d76d7213498d6e499b940ad1a085/5L/TPSIT/Node%20JS/registrazione_punteggi_videogiochi"
                        target="_blank"
                    >
                        Registrazione punteggi
                    </Button>
                </Col>
                {/* Fine 1° Card */}

                {/* Inizio 2° card */}
                <Col className="text-center" md="6">
                    {/* Immagine */}
                    <a href="https://github.com/MattiaBracco05/SCUOLA/tree/494a02a630bb3d1ee07a766e7f6b7da945d9c41b/5L/TPSIT/Node%20JS/verifica_es_module" target="_blank">
                        <img
                        alt="..."
                        className="img-rounded img-responsive"
                        src={require("assets/img/Indice/esempi.jpg")}
                        style={{ width: "100%" }}
                        />
                    </a>
                    {/* Button */}
                    <Button
                        className="btn-outline-neutral btn-round"
                        color="default"
                        href="https://github.com/MattiaBracco05/SCUOLA/tree/494a02a630bb3d1ee07a766e7f6b7da945d9c41b/5L/TPSIT/Node%20JS/verifica_es_module"
                        target="_blank"
                    >
                        Temperature Città
                    </Button>
                </Col>
                {/* Fine 2° card */}

            </Row>
            {/* Fine della 1° riga */}

        </Container>
        {/* Fine del container */}
      </div>
    </>
  );
}

export default CardProgetti;
